import script from "./LessonTypeIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./LessonTypeIcon.vue?vue&type=script&setup=true&lang=js"

import "./LessonTypeIcon.vue?vue&type=style&index=0&id=af795cf4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af795cf4"]])

export default __exports__